module.exports = __webpack_public_path__ + "static/media/domanic_trans.51a27b5a.png";